module.exports = __webpack_public_path__ + "img/inspiration_06@2x.50f9650.webp";